$(function() {

    //FAQ Accordion
    $('.js-faq-tab').on('click', function(){
        console.log(this);
        var $cats = $(this).data('cats');
        $('.faq-tab').removeClass('faq-tab--active');
        $(this).addClass('faq-tab--active');
        $('.faq-accordion').removeClass('faq-accordion--active');
        $('[data-target="'+ $cats +'"]').addClass('faq-accordion--active');

    });

    $('.js-accordion-button').on('click', function(){
        var $target = $(this).data('target');
        $($target + ' .collapse').toggleClass('show');
        $('.accordion__expand .fa-plus', this).toggleClass('d-none');
        $('.accordion__expand .fa-minus', this).toggleClass('d-none');
        $('.accordion__expand', this).toggleClass('faq-accordion__expand--active');

    });

});